<template>
    <div>
        <div class="white-box md:mb-5 pb-12 md:pb-6">
            <transition
                name="opacity"
                mode="out-in"
            >
                <Skeletons v-if="isLoadingData" />
                <div v-else>
                    <ul class="text-tip pb-2.5 border-b border-gray-200">
                        <li>
                            指定生效後，本契約未來給予被保險人之保險給付有未指定帳戶者，例如年金、無理賠回饋保險金...等，得逕予匯入同一人帳戶。
                        </li>
                    </ul>
                    <PolicyAccount
                        v-model:isOpenChange="isOpenChange"
                        v-model:validInput="validInput"
                        v-model:errorResponse="errorResponse"
                        :title="`目前指定的匯款帳戶${showData.isForeignAccount?'(外幣)':'(台幣)'}`"
                        :dataBase="showData"
                        :data="userData"
                        :bankOptions="bankOptions"
                        :branchOptions="branchOptions"
                        @getBranchOptions="getBranchOptions"
                        @getValidResult="getValidResult"
                    />
                </div>
            </transition>
        </div>
        <Bottombar>
            <template #right>
                <ButtonNextService
                    v-model:isSubmitOk="isSubmitOk"
                    :disabled="!isOpenChange"
                    @click="validInput = true"
                />
            </template>
        </Bottombar>
        <Loading :is-loading="isLoading" />
    </div>
</template>

<script>
import { computed, inject, reactive, toRefs } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { getBankInfoB7, getBranchBankInfoB7, getInfoB7, submitB7 } from '@/apis/B7';
import Skeletons from './Skeletons.vue';
import PolicyAccount from '@/components/template/PolicyAccount.vue';
import Bottombar from '@/components/layout/Bottombar.vue';
import ButtonNextService from '@/components/buttons/ButtonNextService.vue';
import Loading from '@/components/Loading.vue';
import dialogContnet from '@/json/dialogContent.js';
import _ from 'lodash';
import { openPopupCatchMessage } from '@/utils/vfmUtils';

export default {
    components: {
        Skeletons,
        PolicyAccount,
        Bottombar,
        ButtonNextService,
        Loading,
    },
    setup() {
        const $vfm = inject('$vfm');
        const route = useRoute();
        const store = useStore();
        const { code } = route.meta;
        const state = reactive({
            isOpenChange: false,
            isLoading: false,
            isLoadingData: false,
            isSubmitOk: false,
            validInput: false,
        });
        const data = reactive({
            showData: {},
            userData: {
                headBankNo: '',
                branchBankNo: '',
                bankAccount: '',
                bankAccountName: '',
                errorMessage: {
                    headBankNo: '',
                    branchBankNo: '',
                    bankAccount: '',
                    bankAccountName: '',
                },
            },
            bankOptions: [],
            branchOptions: [],
            errorResponse: [],
        });
        // 抓已存變更資料
        const result = computed(() => store.state.services.changeItemsResult[code]);

        const getData = async () => {
            state.isLoadingData = true;
            await getBankInfoB7().then((res) => {
                if (res.data) {
                    data.bankOptions = res.data.bankInfoList.map(i => {
                        i.value = i.bankNo;
                        i.label = `${i.bankNo} ${i.bankName}`;
                        return i;
                    });
                }
            });
            getInfoB7().then((res) => {
                if (res.data) {
                    data.showData = {
                        bankAccount: res.data.bankAccount,
                        bankAccountName: res.data.bankAccountName,
                        branchBankName: res.data.branchBankName,
                        branchBankNo: res.data.branchBankNo,
                        headBankName: res.data.headBankName,
                        headBankNo: res.data.headBankNo,
                        isForeignAccount: res.data.foreignAccount,
                    };
                }
            }).finally(() => {
                state.isLoadingData = false;
            });
        };

        if (!result.value) {
            getData();
        } else {
            const {
                showData,
                userData,
                bankOptions,
                branchesOptions,
            } = result.value;
            state.isOpenChange = true;
            data.showData = _.cloneDeep(showData);
            data.userData = _.cloneDeep(userData);
            data.bankOptions = bankOptions;
            data.branchOptions = branchesOptions;
        }

        const getBranchOptions = (headBankNo) => {
            getBranchBankInfoB7(headBankNo).then((res) => {
                if (res.data) {
                    data.branchOptions = res.data.branchBankInfoList.map(i => {
                        i.value = i.bankNo;
                        i.label = `${i.bankNo} ${i.bankName}`;
                        return i;
                    });
                }
            });
        };

        const getValidResult = (hasError, userData) => {
            state.isLoading = true;
            if (hasError) {
                state.isLoading = false;
                modalShow(dialogContnet.validateMsg);
            } else {
                const returnData = {
                    headBankNo: userData.headBankNo,
                    branchBankNo: userData.branchBankNo,
                    bankAccount: userData.bankAccount,
                    bankAccountName: userData.bankAccountName,
                };
                submit(returnData);
            }
        };

        const submit = (returnData) => {
            submitB7(returnData).then(() => {
                const storeData = {};
                storeData.showData = data.showData;
                storeData.userData = data.userData;
                storeData.bankOptions = data.bankOptions;
                storeData.branchesOptions = data.branchOptions;
                store.dispatch('services/setChangeItemsResult', {
                    code,
                    value: storeData,
                });
                state.isSubmitOk = true;
            }).catch((err) => {
                state.isLoading = false;
                const errData = err.data?.details || [];
                if (errData[0]?.field) {
                    data.errorResponse = errData;
                } else {
                    openPopupCatchMessage(err);
                }
            });
        };

        const modalShow = (params) => {
            $vfm.show({
                component: 'DialogBase',
                params,
                on: {
                    confirm() {
                        $vfm.hide('DialogBase');
                    },
                    closed() {
                        $vfm.hide('DialogBase');
                    },
                },
            });
        };

        return {
            ...toRefs(state),
            ...toRefs(data),
            getBranchOptions,
            getValidResult,
        };
    },
};
</script>
